module.exports = "<div class=\"col-lg-12\">\n  <div class=\"row \">\n    <!--Sidebar-->\n    <div class=\"col-lg-4 wow fadeIn\" data-wow-delay=\"0.4s\">\n      <menu [isMenu]=\"isMenu\"></menu>\n    </div>\n    <!--/.Sidebar-->\n    <!--Main column-->\n    <div class=\"col-lg-8 wow fadeIn\" data-wow-delay=\"0.2s\">\n      <router-outlet ></router-outlet>\n    </div>\n  </div>\n  <!--/.Main column-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/orders.component.html
// module id = 920
// module chunks = 1